var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLinkArrow = function SvgExternalLinkArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.486 1.24c0-.396.32-.717.716-.717L9.653.522c.396 0 .718.322.718.717L10.37 7.69a.717.717 0 1 1-1.434 0V2.97L1.24 10.667.225 9.653l7.698-7.697h-4.72a.717.717 0 0 1-.717-.717"
  })));
};
export default SvgExternalLinkArrow;